import instance from './base.service';

export const getHistoryList = async (userBasedHistory, limit = null, page = null) => {
  try {
    const params = new URLSearchParams({ userBasedHistory, limit, page });

    const response = await instance.get('/history', { params });
    return response.data;
  } catch (error) {
    console.log(error);
    return Promise.reject(error);
  }
};

export const getPromptHistory = async ({ contentRequestId, lastRequestTryNumber }) => {
  try {
    const response = await instance.get(
      `/history/${contentRequestId}/tries/${lastRequestTryNumber}`
    );

    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
